export function initConsoleCollector(limit = 200) {
  const logs: any[] = [];
  const orig = {
    log: console.log.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console)
  };

  console.log = (...args: any[]) => {
    logs.push({ type: 'log', args, ts: new Date().toISOString() });
    if (logs.length > limit) logs.shift();
    orig.log(...args);
  };
  console.warn = (...args: any[]) => {
    logs.push({ type: 'warn', args, ts: new Date().toISOString() });
    if (logs.length > limit) logs.shift();
    orig.warn(...args);
  };
  console.error = (...args: any[]) => {
    logs.push({ type: 'error', args, ts: new Date().toISOString() });
    if (logs.length > limit) logs.shift();
    orig.error(...args);
  };

  // Exponer función para obtener los logs
  return () => logs.slice();
}